import type { ComponentProps, ReactNode } from "react"
import cn from "@/v2-ui/utils/utils.cn"

export type ManageItemTextProps = ComponentProps<"div"> & {
  primary: ReactNode
  secondary?: ReactNode
  tag?: ReactNode
}

function ManageItemText(props: ManageItemTextProps) {
  const { primary, secondary, tag, className, ...divProps } = props
  return (
    <div className={cn("manage-item-info", className)} {...divProps}>
      <span className="manage-item-primary">
        {primary}
        {tag && <span className="text-xs text-destructive ml-1">({tag})</span>}
      </span>
      {secondary && <span className="manage-item-secondary">{secondary}</span>}
    </div>
  )
}

export default ManageItemText
